import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import LicensesPage from './pages/LicensesPage';
import ComputersPage from './pages/ComputersPage';
import LicenseTypesPage from './pages/LicenseTypesPage';
import CallbackPage from './pages/CallbackPage';

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/licenses"
            element={
              <PrivateRoute>
                <Layout>
                  <LicensesPage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/computers"
            element={
              <PrivateRoute>
                <Layout>
                  <ComputersPage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/license-types"
            element={
              <PrivateRoute>
                <Layout>
                  <LicenseTypesPage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}
